import {
  CHANNEL_KIND_LABEL,
  DELIVERY_MODE_LABEL,
  PURPOSE_LABEL,
  type CampaignChannelKind,
  type CampaignDeliveryMode,
  type CampaignPurpose,
} from '@workspace/types';

export function wizardSubmitError(params: {
  needsAgent: boolean;
  isWhatsApp: boolean;
  agentId: string;
  channelId: string;
  name: string;
  initialTemplateId: string;
  messageTemplateId: string;
}): string | null {
  if (!params.name.trim()) {
    return 'Completá el nombre.';
  }
  if (params.needsAgent && !params.agentId) {
    return 'Elegí un agente. El modo conversacional abre un diálogo en el bot.';
  }
  if (params.isWhatsApp && (!params.channelId || !params.initialTemplateId.trim())) {
    return params.needsAgent
      ? 'Completá agente, canal de WhatsApp y plantilla.'
      : 'Completá canal de WhatsApp y plantilla.';
  }
  if (!params.isWhatsApp && !params.messageTemplateId) {
    return 'Completá el nombre y una plantilla activa de SMS o email.';
  }
  return null;
}

export function suggestedCampaignName(params: {
  purpose: CampaignPurpose;
  deliveryMode: CampaignDeliveryMode;
  channelKind: CampaignChannelKind;
}): string {
  return `${PURPOSE_LABEL[params.purpose]} · ${DELIVERY_MODE_LABEL[params.deliveryMode]} · ${CHANNEL_KIND_LABEL[params.channelKind]}`.slice(
    0,
    255,
  );
}

export function channelDataLabel(channelKind: string): string {
  return channelKind === 'EMAIL' ? 'email' : 'teléfono';
}

/** Fecha mínima del wizard (mañana) en yyyy-mm-dd. */
export function minCampaignEndDateInput(): string {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  return d.toISOString().slice(0, 10);
}

/** Default del wizard: hoy + 30 días (solo fecha). */
export function defaultCampaignEndDateInput(): string {
  const d = new Date();
  d.setDate(d.getDate() + 30);
  return d.toISOString().slice(0, 10);
}

/** ISO fin del día en Argentina para la API (endsAt). */
export function campaignEndsAtIsoFromDateInput(dateYmd: string): string {
  const day = dateYmd.slice(0, 10);
  return `${day}T23:59:59.999-03:00`;
}

export function validateCampaignEndDateInput(dateYmd: string): string | null {
  const trimmed = dateYmd.trim().slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
    return 'Elegí una fecha de fin válida.';
  }
  const min = minCampaignEndDateInput();
  if (trimmed < min) {
    return 'La fecha de fin debe ser al menos mañana.';
  }
  return null;
}

export function activateUnreachableMessage(params: {
  eligibleCount: number;
  unreachableCount: number;
  channelKind: CampaignChannelKind;
}): string {
  if (params.unreachableCount <= 0) {
    return `Vas a avisar a ${params.eligibleCount}. ¿Seguimos?`;
  }
  const dato = params.channelKind === 'EMAIL' ? 'email' : 'teléfono';
  return `Vas a avisar a ${params.eligibleCount}. ${params.unreachableCount} no tienen ${dato} y no se envían. ¿Seguimos?`;
}
